/**
 * Ek önizlemesi (ortak 2026-10-24 madde 4; ADR 0126): her ekin yanındaki "göz" ve indirme
 * simgeleri, önizleme penceresi. Simgenin adı dosya adını taşır ("Preview <dosya adı>").
 */
export const attachmentPreviewEn = {
  preview: 'Preview {{name}}',
  download: 'Download {{name}}',
  dialog: 'Preview of {{name}}',
  downloadButton: 'Download',
  close: 'Close preview',
  zoomIn: 'Zoom in',
  zoomOut: 'Zoom out',
  fit: 'Fit to window',
  zoom: 'Zoom {{value}}',
  loading: 'Opening the file…',
  page: 'Page {{n}} of {{total}}',
  pagesCut: 'The first {{shown}} of {{total}} pages are shown. Download the file to see all pages.',
  errors: {
    PREVIEW_UNSUPPORTED: 'This file type cannot be previewed. Download it to open.',
    PREVIEW_TOO_LARGE: 'This file is too large to preview. Download it to open.',
    FORBIDDEN: 'You do not have permission to open this file.',
    NOT_FOUND: 'The file was not found.',
    FILE_NOT_UPLOADED: 'The file is still being uploaded from the vessel.',
    FILE_NOT_ON_BOARD: 'The file is not on this vessel’s server.',
    SHIP_UNREACHABLE: 'The vessel server cannot be reached. Try again in a moment.',
    SAVE_FAILED: 'The file could not be saved.',
    default: 'The file could not be opened.',
  },
};

export const attachmentPreviewTr: typeof attachmentPreviewEn = {
  preview: '{{name}} önizle',
  download: '{{name}} indir',
  dialog: '{{name}} önizlemesi',
  downloadButton: 'İndir',
  close: 'Önizlemeyi kapat',
  zoomIn: 'Yakınlaştır',
  zoomOut: 'Uzaklaştır',
  fit: 'Pencereye sığdır',
  zoom: 'Yakınlık {{value}}',
  loading: 'Dosya açılıyor…',
  page: 'Sayfa {{n}} / {{total}}',
  pagesCut: '{{total}} sayfanın ilk {{shown}} sayfası gösteriliyor. Tümü için dosyayı indirin.',
  errors: {
    PREVIEW_UNSUPPORTED: 'Bu dosya türü önizlenemez. Açmak için indirin.',
    PREVIEW_TOO_LARGE: 'Dosya önizleme için çok büyük. Açmak için indirin.',
    FORBIDDEN: 'Bu dosyayı açma yetkiniz yok.',
    NOT_FOUND: 'Dosya bulunamadı.',
    FILE_NOT_UPLOADED: 'Dosya henüz gemiden yükleniyor.',
    FILE_NOT_ON_BOARD: 'Dosya bu geminin sunucusunda yok.',
    SHIP_UNREACHABLE: 'Gemi sunucusuna ulaşılamıyor. Biraz sonra yeniden deneyin.',
    SAVE_FAILED: 'Dosya kaydedilemedi.',
    default: 'Dosya açılamadı.',
  },
};
